export default "__VITE_ASSET__f2bf2c2d__"